"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.YearPickerButtons = exports.getLastFiveYears = exports.getAvailableYears = exports.EARLIEST_YEAR = exports.endOfTheYear = exports.beginningOfTheYear = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const chevronRight_svg_1 = __importDefault(require("../../../assets/icons/chevronRight.svg"));
const hooks_1 = require("../../../store/hooks");
const mapSlice_1 = require("../../../store/mapSlice");
const mapParamsHandler_1 = require("../../../utils/mapParamsHandler");
const S = __importStar(require("./SessionFilters.style"));
const beginningOfTheYear = (year) => new Date(`${year}-01-01T00:00:00Z`).getTime() / 1000;
exports.beginningOfTheYear = beginningOfTheYear;
const endOfTheYear = (year) => new Date(`${year}-12-31T23:59:59Z`).getTime() / 1000;
exports.endOfTheYear = endOfTheYear;
// The earliest year available in the app
exports.EARLIEST_YEAR = 2011;
// Updated function to replace getLastFiveYears
const getAvailableYears = (count = 5) => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let i = 0; i < count; i++) {
        const year = currentYear - i;
        if (year >= exports.EARLIEST_YEAR) {
            years.push(year);
        }
    }
    return years;
};
exports.getAvailableYears = getAvailableYears;
// Keep the original function for backward compatibility
const getLastFiveYears = () => {
    return (0, exports.getAvailableYears)(5);
};
exports.getLastFiveYears = getLastFiveYears;
const YearPickerButtons = () => {
    const dispatch = (0, hooks_1.useAppDispatch)();
    const { timeFrom, updateTime } = (0, mapParamsHandler_1.useMapParams)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const timestampToYear = (timestamp) => {
        const date = new Date(Number(timestamp) * 1000);
        return date.getUTCFullYear();
    };
    const [centerYear, setCenterYear] = (0, react_1.useState)(new Date().getFullYear());
    (0, react_1.useEffect)(() => {
        if (timeFrom) {
            const selectedYear = timestampToYear(timeFrom);
            // Ensure we don't go before EARLIEST_YEAR
            const safeYear = Math.max(selectedYear, exports.EARLIEST_YEAR);
            // Only update centerYear on initial load to prevent visibility shifting
            setCenterYear(safeYear);
        }
    }, []);
    const handleYear = (0, react_1.useCallback)((year) => {
        updateTime(year);
        dispatch((0, mapSlice_1.setFetchingData)(true));
    }, [dispatch, updateTime]);
    const handlePreviousYears = () => {
        if (centerYear > exports.EARLIEST_YEAR) {
            setCenterYear((prev) => Math.max(prev - 1, exports.EARLIEST_YEAR));
        }
    };
    const handleNextYears = () => {
        const currentDate = new Date();
        if (centerYear < currentDate.getFullYear()) {
            setCenterYear((prev) => Math.min(prev + 1, currentDate.getFullYear()));
        }
    };
    const isPreviousDisabled = centerYear <= exports.EARLIEST_YEAR;
    const isNextDisabled = centerYear >= new Date().getFullYear();
    const getVisibleYears = () => {
        const years = [];
        const currentDate = new Date();
        const latestYear = currentDate.getFullYear();
        const adjustedCenterYear = Math.max(centerYear, exports.EARLIEST_YEAR);
        for (let i = 0; i < 4; i++) {
            const year = adjustedCenterYear - i;
            if (year >= exports.EARLIEST_YEAR) {
                years.push(year);
            }
        }
        // If we have fewer than 4 years, add years from the future if possible
        while (years.length < 4 && years[0] < latestYear) {
            const nextYear = years[0] + 1;
            if (nextYear <= latestYear) {
                years.unshift(nextYear);
            }
            else {
                break;
            }
        }
        return years;
    };
    return (react_1.default.createElement(S.SectionButtonsContainer, null,
        react_1.default.createElement(S.ChevronButton, { onClick: handleNextYears, disabled: isNextDisabled, "$isDisabled": isNextDisabled, "$rotated": true },
            react_1.default.createElement("img", { src: chevronRight_svg_1.default, alt: t("filters.previousYear") })),
        getVisibleYears().map((year) => (react_1.default.createElement(S.SectionButton, { key: year, onClick: () => handleYear(year), "$isActive": timestampToYear(timeFrom) === year }, year))),
        react_1.default.createElement(S.ChevronButton, { onClick: handlePreviousYears, disabled: isPreviousDisabled, "$isDisabled": isPreviousDisabled },
            react_1.default.createElement("img", { src: chevronRight_svg_1.default, alt: t("filters.nextYear") }))));
};
exports.YearPickerButtons = YearPickerButtons;
